import { Label, Preloader, Text } from "pctComponents/atoms";
import { PlaceholderTree } from "pctComponents/placehoader";
import "./style.scss";

import React, { useState, useEffect } from "react";
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { getProfileInfo } from "services/utils";
import { getMapFromEnrollment } from "services/api";
import CardBlockMap from "../CardBlockMap";

type Props = {
    collection?: Array<object> | any;
    nodeCodeCurrent?: any;
    setDataMyProgress?: any;
    hasTitle?: boolean;
    closeMap?: any;
    mapElements?: any;
    children?: boolean;
};

function TreeMap({
    collection,
    nodeCodeCurrent,
    setDataMyProgress,
    hasTitle = true,
    closeMap,
    mapElements,
    children = false,
}: Props) {
    const [displayChildren, setDisplayChildren] = useState({});
    const [dataMap, setDataMap] = useState({} as any);

    useEffect(() => {
        let isMounted = true;
        let timeoutId: ReturnType<typeof setTimeout> | undefined;
        let objEnrollment: any = {};

        if (!mapElements) {
            if (collection.hasOwnProperty('idQuestionnaire')) {
                objEnrollment = {
                    idUser: getProfileInfo().idUser,
                    idEnrollment: collection.currentItem.idEnrollment,
                    nodeCode: collection.currentItem.nodeCode,
                    fullMap: collection.isChild == true ? false : true,
                };
            } else if (collection.hasOwnProperty('currentScoObject')) {
                objEnrollment = {
                    idUser: getProfileInfo().idUser,
                    idEnrollment: collection.rootContent.idEnrollment,
                    nodeCode: collection.nodeCode,
                    fullMap: collection.isChild == true ? false : true,
                };
            } else {
                if (collection.hasOwnProperty('currentItem')) {
                    //MAPA DE LIÇÕES SCORM
                    // if(collection.currentItem.idContentType == 26){
                    objEnrollment = {
                        idUser: getProfileInfo().idUser,
                        idEnrollment: collection.currentItem.idEnrollment,
                        nodeCode: collection.currentItem.nodeCode,
                        fullMap: collection.isChild == true ? false : true,
                        // };
                    };
                } else {
                    objEnrollment = {
                        idUser: getProfileInfo().idUser,
                        idEnrollment: collection.contentEnrollment
                            ? collection.contentEnrollment.idEnrollment
                            : collection.nodeEnrollment.idEnrollment,
                        nodeCode: collection.currentItem ? collection.currentItem.nodeCode : collection.nodeCode,
                        fullMap: collection.isChild == true ? false : true,
                    };
                }
            }

            getMapFromEnrollment(objEnrollment)
                .then((response) => {
                    timeoutId = setTimeout(() => {
                        if (!isMounted) {
                            return;
                        }

                        setDataMap(response.data);
                        setDataMyProgress && setDataMyProgress(response.data);
                    }, 1000);
                })
                .catch((error) => {
                    console.log(error);
                });
        } else {
            setDataMap(mapElements);
        }

        return () => {
            isMounted = false;
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
        };
    }, []);

    let items = [] as Array<object> | any;
    items = dataMap['mapElements'];

    if (!dataMap.hasOwnProperty('mapElements')) return <PlaceholderTree number={3} init={hasTitle} />;

    return (
        <>
            <div className={`treeComponent ${children ? 'treeComponentChildren' : ''}`}>
                {dataMap.hasOwnProperty('mapElements') && (
                    <ul>
                        {items?.map((item: any, i) => {
                            let realTitle = item.title;
                            //TODO: SE O PREVITEM FOR IGUAL AO CONTEÚDO ATUAL DA TELA, E A REFERENCIA CONTEÚDO ATUAL ESTIVER COM UM FORCE COMPLETED PRECISAMOS MODIFICAR ESTE ITEM PARA CONCLUÍDO.
                            // CASO O FORCECOMPLETED ESTIVER VERDADEIRO TAMBÉM PRECISAMOS FORÇAR O ITEM PARA COMPLETED 100%
                            // O FORCE COMPLETED SÓ PODE SER ENVIADO QUANDO O CONTEÚDO SCORM FOR DE SCO ÚNICO
                            let prevItem = i > 0 ? items[i - 1] : null;
                            const hasChilds = item.elementType === 'NODE';
                            const mapElementsToPreExpand = item.hasOwnProperty('mapElements')
                                ? { mapElements: item.mapElements, nodeEnrollment: item.nodeEnrollment }
                                : null;

                            return (
                                <li className="item" key={i}>
                                    <>
                                        {/* FILHOS QUE NÃO PRECISAM ESTAR EXPANDIDOS AO INICIAR */}
                                        {hasChilds && !mapElementsToPreExpand && (
                                            <>
                                                <CardBlockMap
                                                    nodeCodeCurrent={nodeCodeCurrent}
                                                    collection={item}
                                                    contentCollection={collection}
                                                    prevItem={prevItem}
                                                    nodeEnrollment={dataMap.nodeEnrollment}
                                                    closeMap={closeMap}
                                                    forceCurrentComplete={collection.forceCurrentComplete}
                                                    onClick={(enrollmentResult) => {
                                                        setDisplayChildren((currentDisplayChildren) => ({
                                                            ...currentDisplayChildren,
                                                            [realTitle]: !currentDisplayChildren[realTitle],
                                                        }));
                                                    }}
                                                    expandButton={(expandEvent) => {
                                                        return (
                                                            <div className="leftInfos">
                                                                <button
                                                                    className={
                                                                        displayChildren[realTitle] ? '' : 'openTree'
                                                                    }
                                                                    onClick={expandEvent}
                                                                >
                                                                    {displayChildren[realTitle] ? (
                                                                        <>
                                                                            <FaChevronUp />
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <FaChevronDown />
                                                                        </>
                                                                    )}
                                                                </button>
                                                            </div>
                                                        );
                                                    }}
                                                />
                                            </>
                                        )}

                                        {/* FILHOS QUE PRECISAM ESTAR EXPANDIDOS AO INICIAR */}
                                        {hasChilds && mapElementsToPreExpand && (
                                            <>
                                                <CardBlockMap
                                                    nodeCodeCurrent={nodeCodeCurrent}
                                                    collection={item}
                                                    contentCollection={collection}
                                                    prevItem={prevItem}
                                                    nodeEnrollment={dataMap.nodeEnrollment}
                                                    closeMap={closeMap}
                                                    isCurrentChild={true}
                                                    forceCurrentComplete={collection.forceCurrentComplete}
                                                    onClick={(enrollmentResult) => {
                                                        setDisplayChildren((currentDisplayChildren) => ({
                                                            ...currentDisplayChildren,
                                                            [realTitle]: !currentDisplayChildren[realTitle],
                                                        }));
                                                    }}
                                                    expandButton={(expandEvent) => {
                                                        return (
                                                            <div className="leftInfos">
                                                                <button
                                                                    className={
                                                                        displayChildren[realTitle] ? '' : 'openTree'
                                                                    }
                                                                    onClick={expandEvent}
                                                                >
                                                                    {displayChildren[realTitle] ? (
                                                                        <>
                                                                            <FaChevronUp />
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <FaChevronDown />
                                                                        </>
                                                                    )}
                                                                </button>
                                                            </div>
                                                        );
                                                    }}
                                                />
                                            </>
                                        )}

                                        {/* SÃO CONTEÚDOS */}
                                        {!hasChilds && (
                                            <CardBlockMap
                                                nodeCodeCurrent={nodeCodeCurrent}
                                                collection={item}
                                                contentCollection={collection}
                                                nodeEnrollment={dataMap.nodeEnrollment}
                                                prevItem={prevItem}
                                                closeMap={closeMap}
                                                forceCurrentComplete={collection.forceCurrentComplete}
                                            />
                                        )}
                                    </>

                                    {displayChildren[realTitle] && (
                                        // <MenuTree collection={item.data["childNodes"]} />
                                        <TreeMap
                                            mapElements={mapElementsToPreExpand}
                                            closeMap={closeMap}
                                            nodeCodeCurrent={nodeCodeCurrent}
                                            collection={{
                                                nodeEnrollment: item.nodeEnrollment,
                                                nodeCode: item.nodeCode,
                                                // currentContentCollection: collection,
                                                currentContentCollection: collection.currentContentCollection
                                                    ? collection.currentContentCollection
                                                    : collection,
                                                isChild: true,
                                            }}
                                            hasTitle={false}
                                            children={true}
                                        />
                                    )}
                                </li>
                            );
                        })}
                    </ul>
                )}
            </div>
        </>
    );
}

export default TreeMap;
